import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classNames from 'classnames'
import createReactClass from 'create-react-class'
import { withGettext } from 'lib/gettext'

import s from '../selected-tags/selected-tags.module.scss'
import a from './tags-ancestry.module.scss'

const TagsAncestry = createReactClass({
  propTypes: {
    gettext: PropTypes.func.isRequired,
    ancestry: PropTypes.array,
    children: PropTypes.node,
  },

  render() {
    return (
      <div className={a.ancestry}>
        {_.map(this.props.ancestry, (ancestor, index) => (
          <div className={a.ancestor} key={`${ancestor}-${index}`}>
            <span key={`${ancestor}-${index}-ancestor`}>
              {this.props.gettext('in')}
            </span>
            <span
              className={classNames([s.title, a.ancestor__chunk])}
              key={`${ancestor}-${index}-chunk`}
            >
              {ancestor}
            </span>
          </div>
        ))}
        {this.props.children}
      </div>
    )
  },
})

export default withGettext(TagsAncestry)
